import { useGlobalizationContext, useTranslation, useGetIndexes } from '@cs-cms/state-management';
import React from 'react';
import { GlobalFiltersLimitConfig } from './GlobalFiltersLimitConfig';
import { MultiFileUploadLimitConfig } from './MultiFileUploadLimitConfig';

export const ConfigurationsManagement: React.FC = () => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);
  const { data: indexes } = useGetIndexes();

  if (!indexes || indexes.length === 0) {
    return (
      <div className="configurationsManagement">
        <div className="configurationsLoading">{translate('custom.settings.adminCenter.configurations.loading')}</div>
      </div>
    );
  }

  return (
    <div className="configurationsManagement">
      <div className="configurationsHeader">
        <h2 className="configurationsTitle">{translate('custom.settings.adminCenter.configurations.title')}</h2>
        <p className="configurationsDescription">
          {translate('custom.settings.adminCenter.configurations.description')}
        </p>
      </div>

      <div className="configurationsContent">
        <GlobalFiltersLimitConfig />

        <MultiFileUploadLimitConfig />
      </div>
    </div>
  );
};
